import { CorporateCard } from '@revenuemarket/bank';

import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

export interface GetCorporateCardListResponse {
  totalElements: number;
  content: CorporateCard[];
}

export default function getCorporateCardList(companyId: string) {
  return API.get<ResponseBaseWithData<GetCorporateCardListResponse>>(
    `/api/v2/companies/${companyId}/corporate-cards?page=0&size=1000`,
  );
}
